module.exports = __webpack_public_path__ + "img/image81.26ca8e0f.png";